import date from './n3Datepicker'
import time from './n3Timepicker'

export default Object.assign({},date,time)


// WEBPACK FOOTER //
// ./src/Locale/n3Datetimepicker.js